function convertBoolToString(boolean) {
  return boolean ? 'Yes' : 'No'
}

export default convertBoolToString
